import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetStateLogsByOrderInput } from './GetStateLogsByOrderInput';
import { GetStateLogsByOrderOutput } from './GetStateLogsByOrderOutput';

export class GetStateLogByOrderService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetStateLogsByOrderInput): Promise<Result<GetStateLogsByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetStateLogsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/state-logs`);
    return promise;
  }
}